import React from 'react'
import Bounce from "react-reveal"

import { ManualList, ModeList } from './Phone.contsant'
import { StyledPhone } from './Phone.style'

import Iphone from "../../assets/images/Iphone.png"
import Samsung from "../../assets/images/Samsung.png"
import Manual1 from "../../assets/images/Manual1.png"
import Manual2 from "../../assets/images/Manual2.png"
import Manual3 from "../../assets/images/Manual3.png"
import Manual4 from "../../assets/images/Manual4.png"

export default function Phone() {
    return (
        <StyledPhone>
            <div className='phone-main'>
                <h1>Manual</h1>
                <div className='redline'><span></span>DOT Instruction:</div>
                <div className='phone-mode'>
                    <div className='phone-img'>
                        <Bounce right>
                            <img src={Iphone} alt='Iphone' />
                        </Bounce>
                    </div>
                    <div className='phone-info'>
                        <h3>SFELDINC ELD Inspection Mode</h3>
                        <div className='phone-list'>
                            {
                                ModeList.map((i) => (
                                    <div className='phone-item' key={i.id}>
                                        {i.icon}
                                        <p>{i.text}</p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className='phone-user'>
                <div className='redline'><span></span>User Manual</div>
                <div className='manual-main'>
                    <div className='manual-list'>
                        <div className='manual-items'>
                            {
                                ManualList.map((i) => (
                                    <div className='manual-item' key={i.id}>
                                        {i.icon}
                                        <div>
                                            <h3>{i.title}</h3>
                                            <p>{i.text}</p>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className='manual-bottom'>
                            <Bounce bottom>
                                <img src={Manual1} alt="Manual1" />
                            </Bounce>
                            <Bounce bottom>
                                <img src={Manual2} alt="Manual1" />
                            </Bounce>
                        </div>
                    </div>
                    <div className='manual-img'>
                        <Bounce right>
                            <img src={Samsung} alt="Samsung" className='samsung' />
                        </Bounce>
                        <div className='manual-bottom'>
                            <Bounce bottom>
                                <img src={Manual3} alt="Manual3" />
                            </Bounce>
                            <Bounce bottom>
                                <img src={Manual4} alt="Manual4" />
                            </Bounce>
                        </div>
                    </div>
                </div>
            </div>
        </StyledPhone>
    )
}
